/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const InboundDocumentState = {
    Active: 'ACTIVE',
    ReplacedBySplit: 'REPLACED_BY_SPLIT',
    HandledThroughScreener: 'HANDLED_THROUGH_SCREENER',
    ArchivedAsJunk: 'ARCHIVED_AS_JUNK',
} as const;
export type InboundDocumentState = typeof InboundDocumentState[keyof typeof InboundDocumentState];


export function instanceOfInboundDocumentState(value: any): boolean {
    for (const key in InboundDocumentState) {
        if (Object.prototype.hasOwnProperty.call(InboundDocumentState, key)) {
            if (InboundDocumentState[key as keyof typeof InboundDocumentState] === value) {
                return true;
            }
        }
    }
    return false;
}

export function InboundDocumentStateFromJSON(json: any): InboundDocumentState {
    return InboundDocumentStateFromJSONTyped(json, false);
}

export function InboundDocumentStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): InboundDocumentState {
    return json as InboundDocumentState;
}

export function InboundDocumentStateToJSON(value?: InboundDocumentState | null): any {
    return value as any;
}

export function InboundDocumentStateToJSONTyped(value: any, ignoreDiscriminator: boolean): InboundDocumentState {
    return value as InboundDocumentState;
}

